<template>
	<v-container pa-0 d-flex justify-center align-center column v-if="user">
		<v-layout
			class="user-profile-container normal-font"
			column
			style="max-width: 600px"
		>
			<div class="dflex">
				<router-link
					:to="
						appType === 'RUMMY'
							? '/reward-section-rummy'
							: '/reward-section'
					"
					class="transparent-background no-text-dec big-font"
					tag="button"
				>
					<div class="back-route">
						<v-icon> keyboard_backspace </v-icon>
						Reward Section
					</div>
				</router-link>
			</div>
			<v-layout class="user-details" column justify-center align-center>
				<img
					class="user-image"
					:src="user.imageUrl || fallBackImageUrl"
				/>
				<div class="big-font">{{ user.teamName }}</div>
				<div class="share-container" v-if="user.phoneNo">
					<div class="share-content">
						<button @click="messageOnWhatsapp(user)">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								aria-hidden="true"
								focusable="false"
								:height="screenProperties.svg"
								:width="screenProperties.svg"
								style="
									-ms-transform: rotate(360deg);
									-webkit-transform: rotate(360deg);
									transform: rotate(360deg);
									width: auto;
								"
								class="share-button"
								preserveAspectRatio="xMidYMid meet"
								viewBox="0 0 1536 1600"
							>
								<path
									d="M985 878q13 0 97.5 44t89.5 53q2 5 2 15q0 33-17 76q-16 39-71 65.5T984 1158q-57 0-190-62q-98-45-170-118T476 793q-72-107-71-194v-8q3-91 74-158q24-22 52-22q6 0 18 1.5t19 1.5q19 0 26.5 6.5T610 448q8 20 33 88t25 75q0 21-34.5 57.5T599 715q0 7 5 15q34 73 102 137q56 53 151 101q12 7 22 7q15 0 54-48.5t52-48.5zm-203 530q127 0 243.5-50t200.5-134t134-200.5t50-243.5t-50-243.5T1226 336t-200.5-134T782 152t-243.5 50T338 336T204 536.5T154 780q0 203 120 368l-79 233l242-77q158 104 345 104zm0-1382q153 0 292.5 60T1315 247t161 240.5t60 292.5t-60 292.5t-161 240.5t-240.5 161t-292.5 60q-195 0-365-94L0 1574l136-405Q28 991 28 780q0-153 60-292.5T249 247T489.5 86T782 26z"
									fill="#2d4970"
								/>
							</svg>
						</button>
						<v-divider class="mx-1" vertical></v-divider>
						<div>
							<a
								:href="
									'tel:' +
										(this.slicePhoneNo(user.phoneNo) || '')
								"
								class="no-text-dec"
							>
								<v-icon
									:size="screenProperties.svg"
									color="#2d4970"
									>phone</v-icon
								>
							</a>
						</div>
						<div class="half-opacity">
							{{ slicePhoneNo(user.phoneNo) }}
						</div>
					</div>
				</div>
				<div
					v-if="
						Math.floor(
							user.rewardStatus.rewardLevels.totalRewardClaimed /
								user.rewardStatus.rewardLevels.totalReward
						) || !user.rewardStatus.expiryStatus.isEligible
					"
				>
					<span class="warning--text big-font">
						No more rewards
					</span>
					<span class="half-opacity">left</span>
				</div>
				<div v-else>
					<span class="success--text big-font"
						>{{ getTimeRemaining(user) }}
					</span>
					<span class="half-opacity">left</span>
				</div>
			</v-layout>
			<v-layout
				class="wallet-detail-container"
				row
				justify-center
				align-center
			>
				<div class="wallet-detail">
					<div>User Wallet</div>
					<div class="big-font">
						&#8377; {{ user.depositBalance }}
					</div>
				</div>
				<v-divider class="mx-1" vertical></v-divider>
				<!-- <div class="vertical-line">&nbsp;</div> -->
				<div class="wallet-detail">
					<div>Commission</div>
					<div class="big-font">
						&#8377;
						{{ user.rewardStatus.rewardLevels.totalRewardClaimed }}
					</div>
				</div>
				<v-divider class="mx-1" vertical></v-divider>
				<!-- <div class="vertical-line">&nbsp;</div> -->
				<div class="wallet-detail">
					<div>Total Recharge</div>
					<div class="big-font">
						&#8377; {{ user.totalRecharged }}
					</div>
				</div>
			</v-layout>
			<v-layout column class="recharge-options">
				<div
					v-if="
						user.rewardStatus.rewardLevels.pendingLevels.length &&
							isTimeRemaining(user) &&
							user.rewardStatus.expiryStatus.isEligible
					"
				>
					Recharge
					<strong
						>&#8377;{{
							user.rewardStatus.rewardLevels.pendingLevels[0]
								.totalRechargeAmount - user.totalRecharged
						}}</strong
					>
					more to get commission of
					<strong
						>&#8377;{{
							user.rewardStatus.rewardLevels.pendingLevels[0]
								.totalReward -
								user.rewardStatus.rewardLevels
									.totalRewardClaimed
						}}</strong
					>
				</div>
				<div>
					<v-btn
						color="#205FB9"
						class="white--text full-width recharge-button big-font"
						@click="openRechargeModal(user)"
					>
						Recharge
					</v-btn>
				</div>
			</v-layout>
			<v-layout class="progress-container" column align-center>
				<!-- <div class="full-width">
					<hr />
				</div> -->
				<div class="progress-line big-font">Progress</div>
				<div class="timeline big-font">
					<div
						class="progress-level completed-level dflex"
						v-for="(reward, index) in user.rewardStatus.rewardLevels
							.completedLevels"
						:key="index"
						align-center
					>
						<div class="progress-element reward">
							<div>Rs. {{ reward.totalReward }}</div>
							<div class="normal-font">Reward</div>
						</div>
						<div class="progress-element check-circle">
							<v-icon color="success">check_circle</v-icon>
						</div>
						<div class="progress-element recharge">
							Recharge for Rs. {{ reward.totalRechargeAmount }}/-
						</div>
					</div>
					<div
						class="progress-level pending-level dflex"
						v-for="(reward, index) in user.rewardStatus.rewardLevels
							.pendingLevels"
						:key="index"
						align-center
					>
						<div class="progress-element reward">
							<div>Rs. {{ reward.totalReward }}</div>
							<div class="normal-font">Reward</div>
						</div>
						<div class="progress-element check-circle">
							<v-icon>check_circle</v-icon>
						</div>
						<div class="progress-element recharge">
							Recharge for Rs. {{ reward.totalRechargeAmount }}/-
						</div>
					</div>
				</div>
			</v-layout>
			<v-dialog width="600px" persistent v-model="transferJeet11Dialog">
				<div class="white-bg pa-4 pos-rel">
					<transfer-money
						model="transferJeet11Dialog"
						:themeInputColor="themeInputColor"
						:jeet11User="jeet11User"
						:payingJeet11User="pay11Jeet11UserLoading"
						:forgetMpin="forgetMpin"
						@CLOSE_MODAL="closeModal"
						:confirmAndPayJeet11User="confirmAndPayJeet11User"
						:isRummyOptionSelected="appType === 'RUMMY'"
					/>
				</div>
			</v-dialog>
			<generate-mpin
				@CLOSE_MODAL="closeModal"
				model="generateMpinDialog"
				v-if="generateMpinDialog"
				:themeInputColor="themeInputColor"
			/>
		</v-layout>
	</v-container>
	<v-container pa-0 d-flex justify-center align-center column v-else>
		<v-layout
			justify-center
			align-center
			d-flex
			class="big-font"
			column
			pa-4
			mt-1
			style="max-width: 600px"
		>
			<div>No user profile selected</div>
			<div class="dflex">
				<router-link
					:to="
						appType === 'RUMMY'
							? '/reward-section-rummy'
							: '/reward-section'
					"
					class="no-text-dec big-font"
					tag="button"
				>
					<v-btn dark :color="themeInputColor"
						>Go to Reward Section</v-btn
					>
				</router-link>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
import { themeInputColor, shareOnWhatsapp } from "@/utils";
import { mapState } from "vuex";
import {
	RESET_JEET11_USER_PROFILE,
	PAY_JEET11_USER,
	PAY_RUMMY_USER
} from "@/store/action-types";
import TransferMoney from "../RechargeHistory/TransferMoney";
import GenerateMPIN from "../GenerateMPIN";
export default {
	components: {
		"transfer-money": TransferMoney,
		"generate-mpin": GenerateMPIN
	},
	data() {
		return {
			themeInputColor,
			jeet11User: null,
			transferJeet11Dialog: false,
			pay11Jeet11UserLoading: false,
			generateMpinDialog: false,
			fallBackImageUrl:
				"https://www.jeet11.com/assets/png/random-user.png",
			appType: "JEET11"
		};
	},
	mounted() {
		this.appType = this.$route.params.appType;
	},
	beforeDestroy() {
		this.$store.dispatch(RESET_JEET11_USER_PROFILE.dispatch);
	},
	computed: {
		...mapState({
			user: state =>
				state.jeet11.jeet11PartnerRechargeHistory.jeet11UserProfile
		}),
		screenProperties() {
			switch (this.$vuetify.breakpoint.name) {
				case "xs":
					return {
						svg: "16px",
						isMobileDevice: true
					};
				case "sm":
					return {
						svg: "20px",
						isMobileDevice: false
					};
				case "md":
					return {
						svg: "20px",
						isMobileDevice: false
					};
				case "lg":
					return {
						svg: "20px",
						isMobileDevice: false
					};
				case "xl":
					return {
						svg: "20px",
						isMobileDevice: false
					};
				default:
					return {};
			}
		}
	},
	methods: {
		duration(date1, date2) {
			if (date2 < date1) return "Time's up";
			let delta = (date2 - date1) / 1000;
			const days = Math.floor(delta / 86400);
			return days + " days ";
		},
		getTimeRemaining(user) {
			if (user.rewardStatus.expiryStatus.isEligible) {
				const expiryDate = new Date(
					user.rewardStatus.expiryStatus.expiryDate
				);
				const today = new Date();
				return this.duration(today, expiryDate);
			}
		},
		slicePhoneNo(phoneNo) {
			return phoneNo ? phoneNo.toString().slice(2) : phoneNo;
		},
		isTimeRemaining(user) {
			if (user.rewardStatus.expiryStatus.isEligible) {
				const expiryDate = new Date(
					user.rewardStatus.expiryStatus.expiryDate
				);
				const today = new Date();
				return expiryDate > today;
			} else return true;
		},
		openRechargeModal(jeet11User) {
			this.jeet11User = {
				...jeet11User,
				phoneNo: this.slicePhoneNo(jeet11User.phoneNo)
			};
			this.transferJeet11Dialog = true;
		},
		closeModal(payload) {
			this[payload] = false;
		},
		confirmAndPayJeet11User(payload) {
			if (!this.pay11Jeet11UserLoading) {
				this.pay11Jeet11UserLoading = true;
				return this.$store
					.dispatch(
						this.appType === "RUMMY"
							? PAY_RUMMY_USER.dispatch
							: PAY_JEET11_USER.dispatch,
						{
							...payload
						}
					)
					.catch(() => {})
					.then(() => {
						this.pay11Jeet11UserLoading = false;
						this.transferJeet11Dialog = false;
						this.$router.replace(
							this.appType === "RUMMY"
								? "/reward-section-rummy"
								: "/reward-section"
						);
					});
			}
		},
		forgetMpin() {
			this.generateMpinDialog = true;
		},
		messageOnWhatsapp(jeet11User) {
			shareOnWhatsapp("", "", jeet11User.phoneNo);
		}
	}
};
</script>

<style scoped lang="scss">
* {
	color: #2d4970;
}
button:focus {
	outline: none;
}
.white-bg {
	background: #fff;
}
.v-icon {
	vertical-align: baseline;
}
.vertical-line {
	border: 1px solid rgba(0, 0, 0, 0.5);
	padding: 4px 0;
	width: 1px;
}
.normal-font {
	font-size: 11px;
	font-weight: 400;
}
.big-font {
	font-size: 13px;
	font-weight: 500;
}
.bigger-font {
	font-size: 24px;
	font-weight: 500;
}
.huge-font {
	font-size: 30px;
	font-weight: 500;
}
.half-opacity {
	opacity: 0.5;
}
.transparent-background {
	background: none;
}
.dflex {
	display: flex;
	flex: 1 1 auto;
}
.dflex.column {
	flex-direction: column;
}
.user-profile-container {
	.user-details {
		margin-bottom: 16px;
	}
	.wallet-detail-container {
		margin-bottom: 16px;
		.wallet-detail {
			width: 33.33%;
			div {
				display: flex;
				flex: 1 1 auto;
				justify-content: center;
			}
		}
	}
	.back-route {
		background: none;
		margin-bottom: 8px;
		display: flex;
		align-items: center;
	}
	.user-image {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		margin: 8px 0;
	}
	.share-container {
		display: flex;
		flex: 1 1 auto;
		width: 100%;
		justify-content: center;
		align-items: center;
		.share-content {
			display: flex;
			background-color: #edf0f7;
			padding: 4px;
			border-radius: 8px;
			margin: 4px;
			align-items: flex-start;
			* {
				margin: 0 2px;
			}
		}
	}
	.recharge-options {
		margin: 8px 0;
		.recharge-button {
			margin: 0;
			text-transform: capitalize;
		}
	}
	.progress-container {
		margin: 8px 0;
		.timeline {
			width: 100%;
			.progress-level {
				justify-content: center;
				align-items: center;
				.progress-element {
					display: flex;
					flex-direction: column;
					padding: 8px 6px;
				}
				.progress-element.reward {
					flex: 1 1 30%;
					text-align: right;
				}
				.progress-element.check-circle {
					flex: 1 1 10%;
					text-align: center;
				}
				.progress-element.recharge {
					flex: 1 1 60%;
					text-align: left;
				}
			}
			.completed-level * {
				color: #205fb9;
			}
			.pending-level * {
				color: #575f6b;
			}
		}
		.progress-line {
			border-bottom: 1px solid black;
			padding-top: 8px;
			margin-bottom: 8px;
		}
	}
}

@media (min-width: 414px) {
	.normal-font {
		font-size: 14px;
	}
	.big-font {
		font-size: 16px;
	}
}
@media screen and (min-width: 600px) {
	.normal-font {
		font-size: 16px;
	}
	.big-font {
		font-size: 18px;
	}
	.user-profile-container {
		padding: 16px;
	}
}
</style>
